import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.3962 15.9853C12.1961 16.2453 11.8039 16.2453 11.6038 15.9853L7.42353 10.555C7.17044 10.2262 7.40482 9.75 7.81974 9.75L16.1803 9.75C16.5952 9.75 16.8296 10.2262 16.5765 10.555L12.3962 15.9853Z",
		fill: "black"
	})
});
export { SvgArrowDown as ReactComponent };
